var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cpinfolist"},_vm._l((_setup.list),function(item,index){return _c('div',{key:index,staticClass:"cpinfolist-item"},[_c('span',{staticClass:"cpinfolist-item_key"},[_vm._v(_vm._s(item.label))]),_c('span',{staticClass:"cpinfolist-item_value"},[_vm._v(_vm._s(item.info))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }